const DELIMITER = ' | ';

export interface DurationTracker {
  markTransactionStart(
    fullArtifactId: string,
    componentId: string,
    transactionName: string,
    transactionId?: number | string,
  ): void;

  markTransactionFinish(
    fullArtifactId: string,
    componentId: string,
    transactionName: string,
    transactionId?: number | string,
  ): number;

  markPhaseStart(
    fullArtifactId: string,
    componentId: string,
    phaseName: string,
  ): void;

  markPhaseFinish(
    fullArtifactId: string,
    componentId: string,
    phaseName: string,
  ): number;
}

class DurationTrackerImpl implements DurationTracker {
  private transactionStartTimes: Record<string, number> = {};
  private phaseStartTimes: Record<string, number> = {};

  private createKey(...args: (number | string | undefined)[]) {
    return args.filter((x) => !!x).join(DELIMITER);
  }

  markTransactionStart(
    fullArtifactId: string,
    componentId: string,
    transactionName: string,
    transactionId?: number | string,
  ) {
    const key = this.createKey(
      fullArtifactId,
      componentId,
      transactionName,
      transactionId,
    );

    this.transactionStartTimes[key] = Date.now();
  }

  markTransactionFinish(
    fullArtifactId: string,
    componentId: string,
    transactionName: string,
    transactionId?: number | string,
  ) {
    const key = this.createKey(
      fullArtifactId,
      componentId,
      transactionName,
      transactionId,
    );
    const finishTime = Date.now();
    const startTime = this.transactionStartTimes[key] || finishTime;
    const duration = Math.round(finishTime - startTime);

    this.transactionStartTimes[key] = 0;

    return duration;
  }

  markPhaseStart(
    fullArtifactId: string,
    componentId: string,
    phaseName: string,
  ) {
    const key = this.createKey(fullArtifactId, componentId, phaseName);

    this.phaseStartTimes[key] = Date.now();
  }

  markPhaseFinish(
    fullArtifactId: string,
    componentId: string,
    phaseName: string,
  ) {
    const key = this.createKey(fullArtifactId, componentId, phaseName);
    const finishTime = Date.now();
    const startTime = this.phaseStartTimes[key] || finishTime;
    const duration = Math.round(finishTime - startTime);

    this.phaseStartTimes[key] = 0;

    return duration;
  }
}

export const createDurationTracker = () => new DurationTrackerImpl();
